// extracted by mini-css-extract-plugin
export var container = "_qx-0";
export var table = "_qx-2";
export var tableWrapper = "_qx-1";